/* Análise → Fornecedores e materiais: materiais comprados, fornecedores e descrições. */

import { api } from '../../core/api';
import { esc, lista, nf, num, pct, unidadeTela } from '../../core/formato';
import type { PorDescricao, PorFornecedor, PorMaterial } from '../../tipos/api';
import { carregar } from '../../ui/carregar';
import { loading, tabela, vazio } from '../../ui/componentes';
import { filtrosBar, paramsFiltro } from '../../ui/filtros';
import type { Pagina } from '../pagina';

export const fornecedores: Pagina = {
  render: () => `
  <h1 class="page">Fornecedores e materiais</h1>
  <p class="sub">Os materiais comprados, os fornecedores (pelo CNPJ informado no lançamento) e as descrições de lançamento que concentram mais emissões.</p>
  ${filtrosBar({ escopo: true })}
  <div class="card" style="margin-bottom:18px"><h2 class="sec">Materiais comprados (bens e serviços)</h2><div id="aMat">${loading()}</div></div>
  <div class="grid g2" style="align-items:start">
    <div><h2 class="sec">Top 5 fornecedores</h2><div id="aForn">${loading()}</div></div>
    <div><h2 class="sec">Principais lançamentos por descrição</h2><div id="aDesc">${loading()}</div></div>
  </div>`,

  carregar(tk) {
    const params = paramsFiltro();
    carregar(tk, [
      {
        id: 'aMat',
        busca: () => api<PorMaterial[]>('GET', '/por-material', { params }),
        html: (d: PorMaterial[]) => {
          const l = lista<PorMaterial>(d);
          const tot = l.reduce((a, x) => a + num(x.total_emissoes), 0);
          if (!l.length) return vazio('Nenhuma compra de material para os filtros selecionados.');
          return tabela<PorMaterial>([
            { l: 'Material', f: (x) => `<b>${esc(x.material)}</b>` },
            { l: 'Quantidade', r: true, f: (x) => (x.quantidade == null ? '—' : `${nf(x.quantidade, 2)} ${esc(unidadeTela(x.unidade || ''))}`) },
            { l: 'Valor (R$)', r: true, f: (x) => (num(x.valor_total) ? nf(x.valor_total, 2) : '—') },
            { l: 'Lançamentos', r: true, f: (x) => nf(x.quantidade_registros, 0) },
            { l: 'tCO₂e', r: true, f: (x) => `<b>${nf(x.total_emissoes, 2)}</b>` },
            { l: '%', r: true, f: (x) => pct(x.total_emissoes, tot) },
          ], l, ['Total', '', '', nf(l.reduce((a, x) => a + num(x.quantidade_registros), 0), 0), nf(tot, 2), '100%']);
        },
      },
      {
        id: 'aForn',
        busca: () => api<PorFornecedor[]>('GET', '/por-fornecedor', { params }),
        html: (d: PorFornecedor[]) => tabela<PorFornecedor>([
          { l: 'CNPJ do fornecedor', f: (x) => `<span class="num" style="font-weight:600">${esc(x.cnpj_fornecedor || 'Sem CNPJ')}</span>` },
          { l: 'Lançamentos', r: true, f: (x) => nf(x.quantidade_registros, 0) },
          { l: 'tCO₂e', r: true, f: (x) => `<b>${nf(x.total_emissoes, 2)}</b>` },
        ], lista<PorFornecedor>(d)),
      },
      {
        id: 'aDesc',
        busca: () => api<PorDescricao[]>('GET', '/por-descricao', { params }),
        html: (d: PorDescricao[]) => tabela<PorDescricao>([
          { l: 'Descrição', f: (x) => `<span style="font-weight:600">${esc(x.descricao)}</span>` },
          { l: 'Lançamentos', r: true, f: (x) => nf(x.quantidade_registros, 0) },
          { l: 'tCO₂e', r: true, f: (x) => `<b>${nf(x.total_emissoes, 2)}</b>` },
        ], lista<PorDescricao>(d)),
      },
    ]);
  },
};
